import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col,
  FormGroup,
  Input,
  Label,
  Table,
} from "reactstrap";
import { getOrderById } from "store/actions/orderActions";
const ViewOrderDetails = ({ viewDetailsToggle, viewDetails, singleOrder }) => {
  const { order } = useSelector((state) => state.orders);

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getOrderById(singleOrder?.orderId));
  }, [singleOrder]);

  const capitalize = (str) => {
    if (!str) return "";
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };
  return (
    <div>
      <Modal isOpen={viewDetails} toggle={viewDetailsToggle} size="lg">
        <ModalHeader toggle={viewDetailsToggle}>Order Details</ModalHeader>
        <ModalBody>
          <Row>
            <Col md={6}>
              <FormGroup>
                <Label>Payment Method</Label>
                <Input readOnly value={capitalize(order?.paymentMethod)} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Order Type</Label>
                <Input readOnly value={capitalize(order?.orderType)} />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Status</Label>
                <Input readOnly value={capitalize(order?.status)} />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label>Table Number</Label>
                <Input
                  readOnly
                  value={order?.tableNumber ? order?.tableNumber : "N/A"}
                />
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <Label>Tip</Label>
                <Input readOnly value={order?.tip ? order?.tip : "N/A"} />
              </FormGroup>
            </Col>
            {/* <Col md={6}>
              <FormGroup>
                <Label>Tip Type</Label>
                <Input readOnly value={order?.tipType ? order?.tip : "N/A"} />
              </FormGroup>
            </Col> */}
            <Col md={6}>
              <FormGroup>
                <Label>Total Amount</Label>
                <Input
                  readOnly
                  value={order?.totalAmount ? order?.totalAmount : "N/A"}
                />
              </FormGroup>
            </Col>
            {/* <Col md={6}>
              <FormGroup>
                <Label>Total Price Item</Label>
                <Input readOnly value={order?.totalPriceItem} />
              </FormGroup>
            </Col> */}
            <Col md={12}>
              <Table bordered className="text-center align-middle">
                <thead>
                  <tr>
                    <th>Item Name</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Size</th>
                    <th>Total Price</th>
                  </tr>
                </thead>
                <tbody>
                  {order?.order?.length > 0 ? (
                    order.order.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.name || "-"}</td>
                        <td>{item?.quantity || 0}</td>
                        <td>Rs {item?.price?.toFixed(2)}</td>
                        <td>{item?.size || "-"}</td>
                        <td>Rs {item?.totalPrice?.toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="text-muted">
                        No items found in the order.
                      </td>
                    </tr>
                  )}
                </tbody>
              </Table>
            </Col>
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="primary" onClick={viewDetailsToggle}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ViewOrderDetails;
